<template>
    <th class="kgr-table__cell kgr-table__cell--headline">
        <slot></slot>
    </th>
</template>

<script>
export default {
    props: {
        sortable: Boolean,
        type: {
            default: 'string',
            validator: function(value) {
                return $.inArray(value, ['string', 'date']) !== -1
            }
        }
    }
}
</script>
